import {
  PURCHASE_BAR_VISIBLITY_CLASS,
  SIDE_BAR_VISIBLITY_CLASS
} from '../classnames/third-party-buttons';

export default class ThirdPartyLinksHandler {
  hideForPurchaseBar = () => {
    if (this.isMobile()) {
      document.body.classList.add(PURCHASE_BAR_VISIBLITY_CLASS);
    }
  };

  showForPurchaseBar = () => {
    if (this.isMobile()) {
      document.body.classList.remove(PURCHASE_BAR_VISIBLITY_CLASS);
    }
  };

  hideForSideBar = () => {
    document.body.classList.add(SIDE_BAR_VISIBLITY_CLASS);
  };

  showForSideBar = () => {
    document.body.classList.remove(SIDE_BAR_VISIBLITY_CLASS);
  };

  isMobile = () => window.innerWidth < 768;
}
